import { render, staticRenderFns } from "./sort-edit.vue?vue&type=template&id=76467517&scoped=true&"
import script from "./sort-edit.vue?vue&type=script&lang=js&"
export * from "./sort-edit.vue?vue&type=script&lang=js&"
import style0 from "./sort-edit.vue?vue&type=style&index=0&id=76467517&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76467517",
  null
  
)

export default component.exports